<style lang="scss">
.ar-line-control {
  position: relative;
  height:6px;
  background-color: rgb(230, 230, 230);
  &__head {
    position: absolute;
    height: inherit;
    background-color: rgb(95, 207, 128);
    border-radius: inherit;
  }
}

.n-ar-player-bar .ar-line-control {
  background: #fff !important;
  border: 1px solid #aaa;
  border-radius: 5px;
  height: 8px;
}

.n-ar-player-bar .ar-line-control__head {
  background: rgb(7, 127, 131) !important;
  
}
.ar-line-head-img {
  width:20px;
  position:absolute;
  right: -5px;
    top: -6px;
}
.n-ar-player-bar .ar-line-head-img{
  display: none;
}

</style>

<template>
  <div :ref="refId" class="ar-line-control" @mousedown="onMouseDown">
    <div class="ar-line-control__head" :style="calculateSize">
      <img class="ar-line-head-img" src="@/assets/img/toefl/ar-line-head.png" />
    </div>
  </div>
</template>

<script>
import { calculateLineHeadPosition } from '@/components/toefl/audio/lib/utils'

export default {
  props: {
    refId: { type: String },
    eventName: { type: String },
    percentage: { type: Number, default: 0 },
    rowDirection: { type: Boolean, default: true }
  },
  methods: {
    onMouseDown(ev) {
      const seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId])
      this.$emit('change-linehead', seekPos)
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseUp(ev) {
      document.removeEventListener('mouseup', this.onMouseUp)
      document.removeEventListener('mousemove', this.onMouseMove)
      const seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId])
      this.$emit('change-linehead', seekPos)
    },
    onMouseMove(ev) {
      const seekPos = calculateLineHeadPosition(ev, this.$refs[this.refId])
      this.$emit('change-linehead', seekPos)
    }
  },
  computed: {
    calculateSize() {
      const value = this.percentage < 1 ? this.percentage * 100 : this.percentage
      return `${this.rowDirection ? 'width' : 'height'}: ${value}%`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toefl/audio/components/line-control.vue